import rejectBooking from "./rejectBooking/rejectBooking.html";
import rejectBookingCtrl from "./rejectBooking/rejectBooking.controller";

class Controller {
  constructor(
    Events,
    Messages,
    $state,
    Sections,
    $stateParams,
    $mdDialog,
    BackupPlan,
    BookingsTransforms,
    Bookings
  ) {
    "ngInject";

    this.Events = Events;

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;

    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.sections = Sections.plansSections;
    this.BackupPlan = BackupPlan;
    this.Messages = Messages;
    this.fields = BookingsTransforms.pendingBookingsFields;
    this.Bookings = Bookings;
    this.bookingActions = [
      { title: "Self Assign", method: this.selfAssign.bind(this) },
      { title: "approve", method: this.approve.bind(this) },
      { title: "reject", method: this.reject.bind(this) },
    ];

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  selfAssign(booking) {
    const confirm = this.$mdDialog
      .confirm()
      .title("Are you sure")
      .textContent(
        `You want to assign ${
          (booking ? booking.rideName : "") || "this booking"
        } to you?`
      )
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        this.Bookings.selfAssignBookingReview(booking._id).$promise.then(
          (data) => {
            booking.status = "in_review";
            booking.reviewer = data.reviewer;
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      },
      () => {}
    );
  }
  approve(booking) {
    const confirm = this.$mdDialog
      .confirm()
      .title("Are you sure")
      .textContent(
        `You want to approve ${
          (booking ? booking.rideName : "") || "this booking"
        }?`
      )
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        this.Bookings.approveBooking(booking._id).$promise.then(
          () => {
            booking.status = "approved";
            this.refreshPage();
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      },
      () => {}
    );
  }
  reject(booking) {
    const confirm = this.$mdDialog.show({
      controller: rejectBookingCtrl,
      template: rejectBooking,
      controllerAs: "$ctrl",
    });

    confirm.then(
      ({ rejectionReason }) => {
        this.Bookings.rejectBooking(booking._id, rejectionReason).$promise.then(
          () => {
            booking.status = "rejected";
            this.refreshPage();
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      },
      () => {}
    );
  }
  refreshPage() {
    this.$state.transitionTo(
      "pendingBookings",
      { page: this.page, limit: this.limit },
      { reload: true }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/pendingBooking/pendingBooking.controller.js